import { AppChip } from "../../../../../../shared/components/AppChip";
import classNames from "classnames";
import { TObjectShareResponse } from "../../../../../../services/api/instances/storageApi/types/service_types";
import { AutocompleteRenderGetTagProps } from "@mui/material";
import styles from "./styles.module.css";

interface Props {
  permission: TObjectShareResponse;
  tags: string[];
  isExpanded: boolean;
  visibleCount: number;
  toggle: () => void;
  getTagProps: AutocompleteRenderGetTagProps;
  handleRevokeAccess: (id: number) => void;
}

export const UserAutocompleteTags = ({
  tags,
  isExpanded,
  permission,
  visibleCount,
  toggle,
  getTagProps,
  handleRevokeAccess,
}: Props) => {
  const visibleTags = tags.slice(0, visibleCount);
  const hiddenCount = tags.length - visibleCount;

  const tagsWrapperCls = classNames(styles["tags-wrapper"], {
    [styles["tags-wrapper--collapsed"]]: !isExpanded && hiddenCount > 0,
  });
  return (
    <div className={styles["tags-container"]}>
      <div className={tagsWrapperCls}>
        {visibleTags.map((tag, index) => {
          const { onDelete, className, ...tagProps } = getTagProps({ index });
          const pair = permission.permission_pairs?.find(
            (p) => p.username === tag.replace("@education_tools", ""),
          );
          return (
            <AppChip
              label={tag}
              className={styles["custom-chip"]}
              {...tagProps}
              key={tag}
              onDelete={(event) => {
                if (pair) handleRevokeAccess?.(pair.id);
                onDelete(event);
              }}
            />
          );
        })}
      </div>

      {!isExpanded && hiddenCount > 0 && (
        <AppChip
          label={`+${hiddenCount}`}
          onClick={(e) => {
            e.stopPropagation();
            toggle();
          }}
          className={styles["tags-counter"]}
        />
      )}
    </div>
  );
};
